import { useSelector } from "react-redux";
import colors from "../constants/colorConstants.js";
import { allowedThemes } from "../constants/colorConstants.js";

const useColors = () => {
  const currentTheme = useSelector((state) => state.systemState.theme);
  const currentColors = colors[currentTheme] ?? {};

  return [currentColors, currentTheme, allowedThemes];
};

export default useColors;
